<app-tabs>
  <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">Admitted Patients</li>
</app-tabs>

<div [hidden]="tabs_service.is_active()"><app-admissions-filter></app-admissions-filter></div>


